import React, { PropTypes } from 'react';

let ChefCard = ({href, title, name, corner, img, ...props}) => ({
  render () {
    return (
        <div className="profile-list-item l-grid__item u-width-one-third lap-u-width-one-half palm-u-width-one-whole u-margin-b-m">
          <div className="card card-recipe">
            <a href={ href }>
              <div className="card-thumbnail theme-light u-margin-b-s">
                {corner &&
                  <div className={'category-corner category-corner-' + corner.toLowerCase()}>
                    <div className="category-corner-triangle category-corner-triangle-band"></div>
                    <div className="category-corner-triangle category-corner-triangle-top"></div>
                    <div className="category-corner-text">{corner}</div>
                  </div>
                }
                <div className="card-thumbnail__image__profile" style={{ backgroundImage: "url(" + img + ")" }}></div>
              </div>
              <div className="u-text-center u-padding-a-m">
                <span className="u-margin-a-n title-profile">{ name }</span>
                <p>{ title }</p>
              </div>
            </a>
          </div>
        </div>
      );
    }
  });

let OurChefs = React.createClass ({

  render () {
    return (
      <div>
        <h1 className="title-large u-margin-t-xl u-margin-b-l u-padding-l-s u-padding-r-s">Våra kockar</h1>
        {/*<p>Här presenterar vi våra kockar och skribenter</p>*/}
        <div className="l-grid chefs profile-list">
          <ChefCard
            href= '/profil/per-morberg'
            name= 'Per Morberg'
            title= 'Skådespelare/Kock'
            corner= 'Profil'
            img= '/bilder/profil-liten/1/per-morberg.jpg'
          />
          <ChefCard
            href= '/profil/henrik-norstrom'
            name= 'Henrik Norström'
            title= 'Kock'
            corner= 'Profil'
            img= '/bilder/profil-liten/26/henrik-norstrom.jpg'
          />
          <ChefCard
            href= '/profil/padma-lakshmi'
            name= 'Padma Lakshmi'
            title= 'Kock/Modell/Artist'
            corner= 'Profil'
            img= '/bilder/profil-liten/3/padma-lakshmi.jpg'
          />
          <ChefCard
            href= '/profil/todd-english'
            name= 'Todd English'
            title= 'Kock/Författare'
            corner= 'Profil'
            img= '/bilder/profil-liten/4/todd-english.jpg'
          />
          <ChefCard
            href= '/profil/helene-henderson'
            name= 'Helene Henderson'
            title= 'Godsägare & Kock'
            corner= 'Profil'
            img= '/bilder/profil-liten/19/helene-henderson.jpg'
          />
          <ChefCard
              href= '/profil/helena-ekman'
              name= 'Helena Ekman'
              title= 'Mästerkock'
              corner= 'Profil'
              img= '/bilder/profil-liten/72/helena-ekman.jpg'
          />
        </div>
        <a href="/profiler" type="button" className="btn">Till våra kockar</a>
      </div>
    );
  }
});


module.exports = OurChefs



// WEBPACK FOOTER //
// ./src/scripts/components/chefs.js